/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import Button from "./com/button";
import { passwordPattern } from "./utils";

const ResetpPg = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [submitText, setSubmitText] = useState("Save Password");
  const { handleSubmit, register, errors } = useForm();
  const { c, m } = useParams();

  const setButtonText = (txt, ca = () => {}, cb = () => {}, wait = 4) => {
    cb();
    setIsLoading(false);
    setSubmitText(txt);
    ca &&
      setTimeout(() => {
        setSubmitText("Login");
        ca();
      }, wait * 1000);
  };

  const onResetp = async ({ password }) => {
    if (!navigator.onLine) return setButtonText("Please check your Internet connection") && false;
    try {
      setIsLoading(true);
      const parms = {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: m, password, resetCode: c }),
        method: "POST",
      };
      const r = await fetch("/patientmanagement/rest/users/resetPassword", parms);
      if (r.ok)
        return setButtonText(
          "Password reset successful. Redirecting to login...",
          () => history.push("/auth/login"),
          () => setIsDisabled(true),
          6
        );
      const j = await r.json();
      setButtonText(j.errors[0].msg);
    } catch (error) {
      setButtonText("Connectivity problem.  Please try again later.");
    }
  };

  return (
    <div className="page">
      <div className="geneva-logo" style={{ transform: "scale(0.6)" }} />
      <div className="root">
        <form onSubmit={handleSubmit(onResetp)} className="tl-form">
          <div className="area">
            <h1>Reset Password</h1>
            <input
              className="tl-inp"
              type="password"
              disabled={isLoading || isDisabled}
              placeholder="Enter password..."
              name="password"
              ref={register({
                required: "Password is required",
                pattern: passwordPattern,
              })}
            />
            <span className="err">{errors.password && errors.password.message}</span>
          </div>
          <Button className="btn tl-btn" disabled={isDisabled} type="submit" isLoading={isLoading}>
            {" "}
            &nbsp; {submitText}{" "}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ResetpPg;
